import React, { Component } from "react";
import { Card, CardHeader, CardText } from "material-ui/Card";
import Avatar from "material-ui/Avatar";
import ReactTooltip from "react-tooltip";
import { filter, includes } from "lodash";
import {
  IconEvent,
  IconPayment,
  IconProperties,
} from "../../components/mui/icon";
import { DivFormFieldBox, SectionForm, DivMain, DivSide } from "../styled";
import {
  renderSideItemForm,
  renderPriceItemForm,
  renderItemFormShipping,
  renderItemFormPaymentMode,
  RenderCard,
} from "../createfield";
import {
  renderItemFormEvent,
  renderProperties,
  renderMainItemForm,
  renderItemFormPlanType,
} from "../edit";
import AdvancePrice from "../AdvancePrice";

const fieldMain = [
  "active",
  "account_id",
  "name",
  "slug",
  "photos",
  "description",
  "category_id",
];
const fieldPrice = ["price", "discount", "margin", "partner_margin"];
const fieldSide = ["brand", "product_type", "tags", "sort_order"];
const fieldPlanType = ["plan_type"];
const fieldEvent = ["event.date", "event.term"];
const fieldPayment = ["payment_mode_id"];
const fieldShipping = [
  "shipping.free_shipping",
  "shipping.weight",
  "shipping.subsidy",
];
class FormMain extends Component {
  constructor(props) {
    super(props);
    const dataMain = filter(
      props.children.props.children,
      (v) => v && includes(fieldMain, v.props.source)
    );
    const dataPrice = filter(
      props.children.props.children,
      (v) => v && includes(fieldPrice, v.props.source)
    );
    const dataSide = filter(
      props.children.props.children,
      (v) => v && includes(fieldSide, v.props.source)
    );
    const dataPlanType = filter(
      props.children.props.children,
      (v) => v && includes(fieldPlanType, v.props.source)
    );
    const dataEvent = filter(
      props.children.props.children,
      (v) => v && includes(fieldEvent, v.props.source)
    );
    const dataPayment = filter(
      props.children.props.children,
      (v) => v && includes(fieldPayment, v.props.source)
    );
    const dataShipping = filter(
      props.children.props.children,
      (v) => v && includes(fieldShipping, v.props.source)
    );

    this.state = {
      categoryName: "",
      categories: {},
      open: false,
      slug: props.record.slug,
      message: "The Slug already have",
      expandedPayment: true,
      expandedEvent: true,
      expandedProperties: true,
      oldVariant: props.variant,
      isGetVariant: false,
      isVariant: false,
      fieldOfMain: dataMain,
      fieldOfPrice: dataPrice,
      fieldOfSide: dataSide,
      fieldOfPlanType: dataPlanType,
      fieldOfEvent: dataEvent,
      fieldOfPayment: dataPayment,
      fieldOfShipping: dataShipping,
    };
  }

  handleExpandPaymentChange = (expanded) => {
    this.setState({ expandedPayment: expanded });
  };

  handleExpandEventChange = (expanded) => {
    this.setState({ expandedEvent: expanded });
  };
  handleExpandPropertiesChange = (expanded) => {
    this.setState({ expandedProperties: expanded });
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.refenceCategories !== null) {
      const categories = nextProps.refenceCategories;

      this.setState({ categoryName: categories.name, categories });
    }
  }

  renderPaymentShippingPropertiesEvent = (
    children,
    record,
    resource,
    basePath
  ) => (
    <div>
      <Card
        expanded={this.state.expandedProperties}
        onExpandChange={this.handleExpandPropertiesChange}
        style={{ marginBottom: 16 }}
      >
        <CardHeader
          title="Properties"
          subtitle=""
          avatar={<Avatar icon={<IconProperties />} />}
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardText expandable={true}>
          <div>
            {renderProperties(
              record,
              resource,
              basePath,
              this.state.categories
            )}
          </div>
        </CardText>
      </Card>
    </div>
  );
  renderMain(children, record, resource, basePath) {
    const {
      fieldOfMain,
      fieldOfPrice,
      fieldOfSide,
      fieldOfPlanType,
      fieldEvent,
      fieldOfPayment,
      fieldOfShipping,
      categoryName,
    } = this.state;
    return (
      <SectionForm>
        <DivMain>
          <RenderCard title="">
            <DivFormFieldBox>
              {fieldOfMain &&
                renderMainItemForm(
                  fieldOfMain,
                  record,
                  resource,
                  basePath,
                  categoryName
                )}
              <ReactTooltip
                id="slugtooltip"
                type="error"
                aria-haspopup="true"
                place="top"
              >
                <span>Such as 'samsungs8' will be ola.id/samsungs8</span>
              </ReactTooltip>
            </DivFormFieldBox>
          </RenderCard>
          {children &&
            this.renderPaymentShippingPropertiesEvent(
              children,
              record,
              resource,
              basePath
            )}
        </DivMain>
        <DivSide>
          <RenderCard title="Price">
            {fieldOfPrice &&
              renderPriceItemForm(fieldOfPrice, record, resource, basePath)}
            <ReactTooltip
              id="discounttooltip"
              type="error"
              aria-haspopup="true"
              place="top"
            >
              <span>0.1 for 10% discount or 20000 for amount</span>
            </ReactTooltip>
            <AdvancePrice {...this.props} />
          </RenderCard>
          <RenderCard title="">
            <DivFormFieldBox>
              {fieldOfSide &&
                renderSideItemForm(fieldOfSide, record, resource, basePath)}
              <ReactTooltip
                id="sort_ordertooltip"
                type="error"
                aria-haspopup="true"
                place="top"
              >
                <span>Higher number will be showing first</span>
              </ReactTooltip>
            </DivFormFieldBox>
          </RenderCard>
          {record.product_type === "Indosat MSP" && (
            <Card
              expanded={this.state.expandedEvent}
              onExpandChange={this.handleExpandEventChange}
              style={{ marginBottom: 16 }}
            >
              <CardHeader
                title="Plan Type"
                subtitle=""
                avatar={<Avatar icon={<IconEvent />} />}
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText expandable={true}>
                <div>
                  {fieldOfPlanType &&
                    renderItemFormPlanType(
                      fieldOfPlanType,
                      record,
                      resource,
                      basePath
                    )}
                </div>
              </CardText>
            </Card>
          )}
          {record.product_type === "Ticket" && (
            <Card
              expanded={this.state.expandedEvent}
              onExpandChange={this.handleExpandEventChange}
              style={{ marginBottom: 16 }}
            >
              <CardHeader
                title="Event"
                subtitle=""
                avatar={<Avatar icon={<IconEvent />} />}
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText expandable={true}>
                <div>
                  {fieldEvent &&
                    renderItemFormEvent(fieldEvent, record, resource, basePath)}
                </div>
              </CardText>
            </Card>
          )}
          <Card
            expanded={this.state.expandedPayment}
            onExpandChange={this.handleExpandPaymentChange}
            style={{ marginBottom: 16 }}
          >
            <CardHeader
              title="Payment Mode"
              subtitle=""
              avatar={<Avatar icon={<IconPayment />} />}
              actAsExpander={true}
              showExpandableButton={true}
            />
            <CardText expandable={true}>
              <div>
                {fieldOfPayment &&
                  renderItemFormPaymentMode(
                    fieldOfPayment,
                    record,
                    resource,
                    basePath
                  )}
              </div>
            </CardText>
          </Card>
          {fieldOfShipping && (
            <RenderCard title="Shipping">
              {renderItemFormShipping(
                fieldOfShipping,
                record,
                resource,
                basePath
              )}
            </RenderCard>
          )}
        </DivSide>
      </SectionForm>
    );
  }
  render() {
    const { children, record, resource, basePath } = this.props;
    return (
      <div>
        {this.renderMain(children.props.children, record, resource, basePath)}
      </div>
    );
  }
}
//
export default FormMain;



// WEBPACK FOOTER //
// ./src/products/form/FormMain.js